var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_158_1078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.339844,
    y: 0.80957,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#4BACEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.812 61.4396C49.192 61.4396 47.802 61.1796 46.642 60.6596C45.482 60.1196 44.532 59.3696 43.792 58.4096C43.072 57.4296 42.532 56.3096 42.172 55.0496C41.832 53.7896 41.662 52.4396 41.662 50.9996V49.7396C41.662 46.0996 42.592 43.3596 44.452 41.5196C46.312 39.6596 49.052 38.7296 52.672 38.7296C53.412 38.7296 54.142 38.7496 54.862 38.7896C55.582 38.8296 56.282 38.8896 56.962 38.9696V43.0796C56.302 43.0196 55.592 42.9696 54.832 42.9296C54.072 42.8696 53.292 42.8396 52.492 42.8396C50.892 42.8396 49.632 43.1096 48.712 43.6496C47.792 44.1696 47.142 44.9596 46.762 46.0196C46.382 47.0796 46.192 48.3896 46.192 49.9496V52.2296L45.112 52.9496C45.132 51.4496 45.432 50.1996 46.012 49.1996C46.612 48.1796 47.432 47.4196 48.472 46.9196C49.512 46.4196 50.712 46.1696 52.072 46.1696C53.612 46.1696 54.942 46.4796 56.062 47.0996C57.182 47.6996 58.042 48.5496 58.642 49.6496C59.242 50.7496 59.542 52.0496 59.542 53.5496C59.542 55.1296 59.182 56.5196 58.462 57.7196C57.742 58.8996 56.722 59.8196 55.402 60.4796C54.102 61.1196 52.572 61.4396 50.812 61.4396ZM50.662 57.3596C51.542 57.3596 52.282 57.1996 52.882 56.8796C53.502 56.5596 53.972 56.1296 54.292 55.5896C54.632 55.0296 54.802 54.3796 54.802 53.6396C54.802 52.8796 54.642 52.2296 54.322 51.6896C54.002 51.1296 53.542 50.6996 52.942 50.3996C52.362 50.0796 51.642 49.9196 50.782 49.9196C50.002 49.9196 49.282 50.0596 48.622 50.3396C47.982 50.5996 47.472 51.0096 47.092 51.5696C46.712 52.1096 46.522 52.7996 46.522 53.6396C46.522 54.3596 46.672 54.9996 46.972 55.5596C47.292 56.1196 47.762 56.5596 48.382 56.8796C49.002 57.1996 49.762 57.3596 50.662 57.3596Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_158_1078",
    x: 0.339844,
    y: 0.80957,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_158_1078"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.2650520ab491751ea37ec2fdf2b478f4.svg";
export { ForwardRef as ReactComponent };